<template>
  <v-dialog
    width="100%"
    max-width="1400px"
    v-model="dialog"
    scrollable
    @keydown.esc="dialog = false"
  >
    <v-card :loading="loading" v-if="item">
      <v-system-bar window dark
        ><span>Kursrechnung</span><v-spacer />
        <v-btn icon @click="dialog = false"
          ><v-icon>mdi-close</v-icon></v-btn
        ></v-system-bar
      >

      <v-card-text class="ma-0 px-4 pt-4">
        <v-row v-if="item">
          <v-col cols="12" md="6" lg="5" xl="5">
            <v-card class="mb-4">
              <v-system-bar>Rechnung</v-system-bar>
              <FinanceInvoice :item="item" />
            </v-card>
            <v-card>
              <v-system-bar>Betrag verteilen</v-system-bar>
              <InvoiceAmount
                :value="item"
                @updateTolerance="updateTolerance"
                readonly
              />
              <v-divider />
              <v-card-actions>
                <v-btn
                  text
                  @click="distribute"
                  :disabled="
                    !item ||
                    (!item.amount && !item.amountForeign) ||
                    !item.details.length
                  "
                  >gleichmässig verteilen</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" lg="7" xl="7">
            <FinanceInvoiceDetailForm v-model="item" distribute />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="dialog = false">abbrechen</v-btn>
        <v-spacer />

        <FinanceInvoiceSave
          :item="item"
          :tolerance="tolerance"
          @saved="saved"
          :valid="true"
          distribute
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { defineComponent } from "vue";
import FinanceInvoice from "common/components/Finance/FinanceInvoice.vue";
import InvoiceAmount from "common/components/Finance/InvoiceAmount.vue";
import FinanceInvoiceDetailForm from "common/components/Finance/FinanceInvoiceDetailForm.vue";
import FinanceInvoiceSave from "common/components/Finance/FinanceInvoiceSave.vue";
import { createInvoice } from "common/utils/finance.js";

export default defineComponent({
  components: {
    FinanceInvoice,
    FinanceInvoiceDetailForm,
    FinanceInvoiceSave,
    InvoiceAmount,
  },
  props: { id: {}, page: { type: String, default: "InvoiceDetails" } },
  data() {
    return {
      dialog: true,
      loading: false,
      item: createInvoice(),
      tolerance: true,
    };
  },

  watch: {
    dialog() {
      if (!this.dialog) {
        this.$router.push({
          name: "FinanceInvoicesNoDetailsDetail",
          params: { id: this.item.id },
        });
      }
    },
  },
  methods: {
    distribute() {
      const details = this.item.details;
      if (this.foreign) {
        const amountForeign =
          Math.floor((100 * this.item.amountForeign) / details.length) / 100;
        details.forEach((detail) => (detail.amountForeign = amountForeign));
      } else {
        const amount =
          Math.floor((100 * this.item.amount) / details.length) / 100;
        details.forEach((detail) => (detail.amount = amount));
      }
    },
    async saved(newId) {
      this.$router.push({
        name: "FinanceInvoicesNoDetailsDetail",
        params: { id: newId },
      });
    },
    updateTolerance(tolerance) {
      this.tolerance = tolerance;
    },
  },
  async created() {
    this.loading = true;
    this.item = await this.apiGet({
      resource: "finance/invoice",
      id: this.id,
    });

    this.loading = false;
  },
});
</script>
